import { moduleText as ui, moduleLocale } from "../../i18n/moduleText";
import {derickText} from '../derick/derickWorkspaceCopy';
const DEFAULT_CONTEXT = Object.freeze({
  get "title"() { return ui("this SBS page"); },
  prompts: [
    "How do I use this page?",
    "What can I do here?",
    "Where should I go next?",
  ],
});

const TMS_PAGE_CONTEXTS = [
  ["routing", "Routing & Quotes", [
    "What can I do in Routing & Quotes?", "Why is Calculate truck routes unavailable?", "Why can't I save my quote?",
  ]],
  ["loads", "Loads & dispatch", [
    "How do I dispatch a load?", "Can I skip a missed check-in?", "How do I share shipment status with a customer?",
  ]],
  ["intake", "Load intake", [
    "How do I import a rate confirmation?", "Does opening Load intake use AI credits?", "Is my load board already connected?",
  ]],
  ["drivers", "Drivers", [
    "How do I link a driver to an HR employee?", "Why is this driver not ready for dispatch?", "How do driver pay defaults work?",
  ]],
  ["fleet", "Fleet & maintenance", [
    "How do I add trucks and trailers?", "How do I track maintenance?", "Why is a unit unavailable for dispatch?",
  ]],
  ["safety", "Safety & Compliance", [
    "How do safety holds affect dispatch?", "Where do I record an inspection?", "Where should I store sensitive employee documents?",
  ]],
  ["finance", "Load finance", [
    "How does a delivered load become a Finance draft?", "Where do trip miles and billable extras appear?", "Does TMS driver pay send a payment?",
  ]],
  ["settlements", "Driver settlements", [
    "How do I prepare a driver settlement?", "What does Record payment do?", "Can an approved settlement be edited?",
  ]],
  ["costs", "Operating costs", [
    "What does the operating cost report include?", "How do truck cost profiles work?", "Why is recorded contribution not net profit?",
  ]],
  ["quarterly", "Quarterly mileage & fuel", [
    "How do I review quarterly mileage and fuel?", "Does SBS file IFTA returns?", "Why is fuel receipt evidence missing?",
  ]],
  ["documents", "Document library", [
    "How do I attach and review proof of delivery?", "Which document formats can I upload?", "How do I download a billing packet?",
  ]],
  ["requests", "Selenne service requests", [
    "How do Selenne service requests work?", "What can a delegated consultant see?", "How do I report a TMS software issue?",
  ]],
  ["setup", "Carrier & staff setup", [
    "How do I set up TMS staff access?", "How do I connect a driver login to an employee?", "How does the carrier time zone work?",
  ]],
  ["", "Command Center", [
    "How do I get started in SBS Smart TMS?", "How do I close and reopen the TMS sidebar?", "Why are some TMS sections missing?",
  ]],
].map(([section, label, prompts]) => ({
  matches: (path) => section
    ? path === `/tms/${section}` || path.startsWith(`/tms/${section}/`)
    : path === "/tms" || path.startsWith("/tms/"),
  get title() { return ui("SBS Smart TMS: {{section}}", { section: ui(label) }); },
  prompts,
}));

const PAGE_CONTEXTS = Object.freeze([
  {matches:path=>path==='/derick',get title(){return derickText(moduleLocale())('Derick workspace');},get prompts(){return ['How do saved conversations work?','How do I check a request that did not finish?','How do I attach a verified Finance report?'].map(derickText(moduleLocale()));}},
  ...[
    ["/distribution/customer/payment-updates", "My Payment Updates", ["How do I report a payment?", "Does reporting a payment reduce my balance?", "Can I report payment for a quote?"]],
    ["/distribution/customer/orders", "My Distribution Orders", ["Where can I see my order progress?", "Where are my shared documents?", "Why is my balance different from my payment report?"]],
    ["/distribution/customer/documents", "My Shared Documents", ["How do I download a shared file?", "Why can't I see an internal document?", "Where can I find an order summary?"]],
    ["/distribution/customer/messages", "My Distribution Messages", ["How do I send an order inquiry?", "Where do distributor replies appear?", "Does a portal message send an email?"]],
    ["/distribution/customer/account", "My Distribution Account", ["How is my login linked to my customer account?", "Why is an order missing?", "Who can help with my access?"]],
    ["/distribution/customer-orders", "Quote and Purchase Order History", ["How do quotes differ from purchase orders?", "Where do I see production, payments and files for an order?", "Why is an item search incomplete?"]],
    ["/distribution/manufacturer-orders", "Manufacturer Production Orders", ["How do I follow production progress?", "Where is the linked customer order?", "How do I print a manufacturer order?"]],
    ["/distribution/payment-tracking", "Distribution Payment Tracking", ["What is the difference between reported and confirmed paid?", "Why did a payment save conflict?", "Does Distribution collect or post payments?"]],
    ["/distribution/messages", "Distribution Messages", ["Where are customer inquiries?", "How do I reply to an order message?", "How do I mark a message read?"]],
    ["/distribution/documents", "Distribution Document Library", ["How do I upload a private document?", "How do I share a file with the customer?", "Does a new version keep the original file?"]],
    ["/distribution/settings", "Distribution Workspace Settings", ["How do I close the sidebar?", "How do I switch language and page help?", "Do these settings change permissions?"]],
    ["/distribution/create-order", "Create Quote or Purchase Order", ["How do I create a quote?", "How do I add products to an order?", "Does creating an order create a customer login?"]],
    ["/distribution/products", "Distribution Products", ["How do I import products?", "What does archiving a product do?", "Where do manufacturer part numbers belong?"]],
    ["/distribution/manufacturers", "Distribution Manufacturers", ["How do I manage manufacturer products?", "Are manufacturer notes visible to customers?", "Does archiving a manufacturer delete history?"]],
    ["/distribution/customers", "Distribution Customers", ["How is a customer record different from a login?", "Where do I manage customer records?", "How do I retain customer history?"]],
    ["/distribution", "Distribution Dashboard", ["What can I do in Distribution?", "Why are quotes separate from pending payments?", "How do I refresh the workspace?"]],
  ].map(([route, title, prompts]) => ({ matches: path => path === route || path.startsWith(route + "/") || (route === "/distribution/customer/account" && path === "/distribution/customer/account-access"), get title() { return ui(title); }, prompts })),
  ...TMS_PAGE_CONTEXTS,
  {
    matches: (path) => path === "/",
    get "title"() { return ui("Today in SBS"); },
    prompts: [
      "What can I view on the Today page?",
      "How do I personalize my workspace?",
      "How do I open the Operations Dashboard?",
    ],
  },
  {
    matches: (path) => path === "/operations" || path === "/dashboard",
    get "title"() { return ui("Operations Dashboard"); },
    prompts: [
      "How do I use the Operations Dashboard?",
      "How do I import General Inventory?",
      "How do the SBS drafting tools work?",
      "How does the Smart Calendar save entries?",
    ],
  },
  {
    matches: (path) => path.startsWith("/managerial-economics"),
    get "title"() { return ui("Business Decision Center"); },
    prompts: [
      "How do I use the Business Decision Center?",
      "What belongs in Current situation and evidence?",
      "What does the readiness score mean?",
      "How do I start a new decision?",
      "How do I turn a decision into a pilot and assigned tasks?",
      "How do I share a decision with Derick?",
    ],
  },
  {
    matches: (path) => path.startsWith("/marketing-center"),
    get "title"() { return ui("Marketing Center"); },
    prompts: [
      "How do I use the Marketing Center?",
      "How do Brand and Audience records connect?",
      "How do I start a new strategy?",
    ],
  },
  {
    matches: (path) => /^\/crm\/contacts\/[^/]+/.test(path),
    get "title"() { return ui("Customer 360"); },
    prompts: [
      "What can I view in Customer 360?",
      "How do I create a connected invoice?",
      "What is the difference between internal notes and client updates?",
    ],
  },
  {
    matches: (path) => path.startsWith("/crm"),
    get "title"() { return ui("CRM"); },
    prompts: [
      "How do I use the CRM?",
      "How are contacts and clients different?",
      "How do deals, projects, and tasks connect?",
    ],
  },
  {
    matches: (path) => path === "/finance" || path === "/transactions" || path === "/payroll",
    get "title"() { return ui("Business Finance Center"); },
    prompts: [
      "How does Accounting Review work?",
      "How do I pull Rapid Records?",
      "What happens when I approve and post an item?",
    ],
  },
  {
    matches: (path) => path.startsWith("/rapid-record"),
    get "title"() { return ui("Rapid Record"); },
    prompts: [
      "How do I save a Rapid Record?",
      "What should I use Not Sure for?",
      "How does a record reach Accounting Review?",
    ],
  },
  {
    matches: (path) => path.startsWith("/cigar-retail"),
    get "title"() { return ui("Cigar Retail Suite"); },
    prompts: [
      "How do I use the Cigar Retail register?",
      "How do cash tender and change work?",
      "How are tobacco tax and sales tax separated?",
      "How do loyalty safeguards work?",
    ],
  },
  {
    matches: (path) => path.startsWith("/website-connector"),
    get "title"() { return ui("Website Connector"); },
    prompts: [
      "How does the protected sandbox work?",
      "What records can a website send to SBS?",
      "How do I activate a reviewed connection?",
    ],
  },
  {
    matches: (path) => path.startsWith("/admin/sys-admin"),
    get "title"() { return ui("SBS System Administration"); },
    prompts: [
      "What can I manage in System Administration?",
      "Where do Derick support tickets appear?",
      "How do company entitlements work?",
    ],
  },
  {
    matches: (path) => path === "/admin" || path === "/settings",
    get "title"() { return ui("Company Control Center"); },
    prompts: [
      "How do I manage company modules?",
      "How do I manage team access?",
      "What can a company administrator change?",
    ],
  },
  {
    matches: (path) => path === "/billing" || path === "/pricing",
    get "title"() { return ui("Subscriptions and Billing"); },
    prompts: [
      "How do SBS subscriptions work?",
      "Where do I manage my subscription?",
      "How is Google Play billing connected to SBS?",
    ],
  },
]);

export function getDerickPageContext(pagePath = "") {
  const normalizedPath = String(pagePath || "/").split(/[?#]/)[0].replace(/\/+$/, "") || "/";
  const context = PAGE_CONTEXTS.find((context) => context.matches(normalizedPath)) || DEFAULT_CONTEXT;
  return { ...context, prompts: context.prompts.map((prompt) => ui(prompt)) };
}

export { DEFAULT_CONTEXT, PAGE_CONTEXTS };
